var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserStatsRev({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 153,
    viewBox: "0 0 197 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197 0H34V37H168.094L197 0Z",
    fill: "#F9E11E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142 58H13V95H113.155L142 58Z",
    fill: "#F9E11E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93 116H0V153H64.3846L93 116Z",
    fill: "#F9E11E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserStatsRev);
export default __webpack_public_path__ + "static/media/user-stats-rev.1ba4a5a0c16f025972e33402c89448a2.svg";
export { ForwardRef as ReactComponent };